import React from 'react';

import Support from 'Components/Support/Support';

import {Modal} from 'Services';

export default class PreAuth extends React.Component {
    /**
     * @method handleOpenSupportModal
     */
    handleOpenSupportModal = () => {
        Modal.open('SupportRequest', {
            component: Support,
            props: {
                user: null,
            },
        });
    };

    /**
     * @method render
     * @return {*}
     */
    render() {
        const {mode} = this.props;

        return (
            <div className={
                'min-h-screen bg-white flex'
            }>
                <div
                    className={
                        'hidden lg:flex w-2/3 items-end bg-no-repeat bg-center bg-app-blue-aetna'
                    }
                    style={{
                        backgroundImage: `url(/images/PT-Home.png)`,
                    }}
                >
                    <div className={'text-white w-1/2 mb-20 ml-20'}>
                        <h2 className={'text-2xl font-bold mb-8'}>
                            Tuthill Porsche
                        </h2>

                        {mode === 'guest-checkin' && (
                            <React.Fragment>
                                <p className="font-thin mb-8">
                                    Welcome to Tuthill Porsche, please sign in on the right
                                </p>
                            </React.Fragment>
                        )}

                        {mode === undefined && (
                            <React.Fragment>
                                <p className={'font-thin mb-8'}>
                                    As an employee of Tuthill Porsche, you should have a
                                    login for this system. Please contact a system administrator if
                                    you cannot gain access.
                                </p>
                            </React.Fragment>
                        )}
                    </div>
                </div>

                <div
                    className={
                        'flex-1 flex flex-col justify-center py-12 px-4 sm:px-6 ' +
                        'lg:flex-none lg:px-20 xl:px-24 w-1/3'
                    }>
                    <div className="mx-auto w-full max-w-sm  border-none">
                        <div>
                            <img className="h-20 w-auto mx-auto"
                                 src={'/images/tuthill-logo.png'}
                                 alt="Workflow"/>
                        </div>

                        {this.props.children}
                    </div>
                </div>
            </div>
        );
    }
}
